import { useEffect, useState } from 'react';
import {
  ITaxTypesDetails,
  saveTaxType,
  updateTaxVisibilityStatus,
  updateTaxType,
  getAllTaxType,
  getTaxTypeList,
} from 'wisestep-api';

import { failed, success, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import {
  invoiceTaxSettingsDefaultPayload,
  ApplyTo,
  IDefaultValue,
  updateTaxStatusQuery,
  InvoiceBreadCrumbListAndTitle,
} from '../helper/InvocieSettingsHelper';

import InvoiceDrawerLayout from './InvoiceDrawerLayout';
import InvoiceSettingsLayout, { ILabelTaxWithStatus } from './InvoiceSettingsLayout';

const TaxTypeDetails = () => {
  const [taxFileds, setTaxFileds] = useState<ITaxTypesDetails[]>([]);
  const [taxCheckBoxList, setTaxCheckBoxList] = useState<ITaxTypesDetails[]>([]);
  const [taxViewCheckBoxList, setTaxViewCheckBoxList] = useState<ITaxTypesDetails[]>([]);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [editTaxationText, setEditTaxationText] = useState<string>('');
  const [viewApplyToText, setViewApplyToText] = useState<string>('');
  const [editTaxationRateText, setEditTaxationRateText] = useState<string>('');
  const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);
  const [openViewDialog, setOpenViewDialog] = useState<boolean>(false);
  const [showViewTaxCheckList, setShowViewTaxCheckList] = useState<boolean>(false);
  const [editTaxIndexValue, setEditTaxIndexValue] = useState<number>(0);
  const [flag, setFlag] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [selectedValue, setSelectedValue] = useState<ITaxTypesDetails>();
  const headerList = [
    'Taxation Name',
    'Taxation Rate',
    'Taxation Application',
    'Visibility',
    'Created By',
    'View',
    'Edit',
  ];

  const taxNote =
    'NOTE:- In case your you have multiple layers of taxation applicable on your invoice, create a separate entry for each tax type. i.e. create a tax type for CGST, SGST and IGST each.';

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllTaxType();
      setTaxFileds(response.data);
      const response1 = await getTaxTypeList();
      setTaxCheckBoxList(response1.data);
    };
    fetchData();
  }, [flag]);

  const categories: ILabelTaxWithStatus[] =
    taxFileds?.map((taxFileds) => ({
      taxType: taxFileds.name,
      createdby: taxFileds?.createdBy ?? '',
      visibility: taxFileds.isActive,
      taxApplication: taxFileds.applyTo,
      createdByName: taxFileds?.createdByName ?? '',
      rate: taxFileds.rate,
      applyToTaxes: taxFileds.applyToTaxes,
    })) ?? [];

  const getDefaultValue: IDefaultValue = {
    fieldOne: selectedValue?.name,
    fieldTwo: selectedValue?.rate,
  };

  const getEditIndexValue = (index: number) => {
    setEditTaxIndexValue(index);
    const tempPayload = taxFileds[index];
    setSelectedValue(tempPayload);
    setOpenEditDialog(true);
    setEditTaxationText(categories[index].taxType);
    setEditTaxationRateText(categories[index].rate);
  };

  const getViewIndexValue = async (index: number) => {
    setShowViewTaxCheckList(false);
    const taxesList: ITaxTypesDetails[] = [];
    const map1 = new Map();
    setOpenViewDialog(true);
    setEditTaxationText(categories[index].taxType);
    setEditTaxationRateText(categories[index].rate);
    setViewApplyToText(categories[index].taxApplication);

    if (categories[index].taxApplication == 'Taxes') {
      setShowViewTaxCheckList(true);
      taxFileds?.forEach((data) => map1.set(data.id, data.name));
      categories[index].applyToTaxes?.forEach(async (data) => taxesList.push(map1.get(data)));
      setTaxViewCheckBoxList(taxesList);
    }
  };

  const onAddNewTaxType = async (data) => {
    const payload = { ...invoiceTaxSettingsDefaultPayload };
    payload.name = data.fieldOne;
    payload.rate = data.fieldTwo;
    payload.isActive = true;
    payload.applyTo = ApplyTo.Invoice;
    if (data.toggled === true) {
      payload.applyTo = ApplyTo.Taxes;
      payload.applyToTaxes = data.applyToTaxes;

      if (data.applyToTaxes.length === 0 && taxCheckBoxList.length > 0) {
        setNotification(warning(`Please select at least one checkbox`));
        return;
      }
    }
    try {
      await saveTaxType(payload);
      setFlag(!flag);
      setNotification(success(`${data.fieldOne} has been added successfully !!`));
      setOpenDialog(false);
    } catch (error: any) {
      if (error.response.status === 400)
        setNotification(warning(`Oops , ${data.fieldOne} already exists!!`));
      else setNotification(failed('Something went wrong !!'));
    }
  };

  const onUpdate = async (data: boolean, index: number) => {
    const tempPayload = taxFileds[index];
    updateTaxStatusQuery.isActive = data;
    try {
      if (tempPayload.id) {
        await updateTaxVisibilityStatus(tempPayload.id, updateTaxStatusQuery);
        setNotification(success('Visibility status has been updated successfully !!'));
        setFlag(!flag);
      } else setNotification(warning('File Category Id not found !!'));
    } catch {
      setNotification(failed('Something went wrong , Please try again !!'));
    }
  };

  const onUpdateTaxType = async (data) => {
    const tempPayload = taxFileds[editTaxIndexValue];
    invoiceTaxSettingsDefaultPayload.name = data.fieldOne;
    invoiceTaxSettingsDefaultPayload.rate = data.fieldTwo;
    if (data.toggled === true) {
      invoiceTaxSettingsDefaultPayload.applyTo = ApplyTo.Taxes;
      invoiceTaxSettingsDefaultPayload.applyToTaxes = data.applyToTaxes;
      if (data.applyToTaxes.length === 0) {
        setNotification(warning(`Please select at least one checkbox`));
        return;
      }
    } else {
      invoiceTaxSettingsDefaultPayload.applyTo = ApplyTo.Invoice;
    }
    try {
      if (tempPayload.id) {
        await updateTaxType(tempPayload.id, invoiceTaxSettingsDefaultPayload);
        setNotification(success('Tax Type has been updated successfully !!'));
        setOpenEditDialog(false);
        setFlag(!flag);
      } else setNotification(warning('File Category Id not found !!'));
    } catch {
      setNotification(failed('Something went wrong , Please try again !!'));
    }
  };
  return (
    <>
      <InvoiceSettingsLayout
        BreadCrumbListAndTitle={InvoiceBreadCrumbListAndTitle['TAX_TYPE']}
        backUrl={'/app-settings/invoice-module'}
        headerList={headerList}
        dataCallback={(data: boolean, index: number) => onUpdate(data, index)}
        itemsTaxList={categories}
        addButtonText="Tax Type"
        handleAddButton={() => setOpenDialog(true)}
        handleEditButton={(index: number) => getEditIndexValue(index)}
        handleViewButton={(index: number) => getViewIndexValue(index)}
        isInvoiceTaxType={true}
      />
      {openDialog && (
        <InvoiceDrawerLayout
          openDialog={openDialog}
          closeDialog={() => setOpenDialog(false)}
          onInput={(data) => onAddNewTaxType(data)}
          name="Add Tax"
          extraField={true}
          addPlaceholder1={'Tax Type'}
          addPlaceholder2={'Tax Rate'}
          isToggledEnabled={true}
          isTaxTypeDrawer={true}
          toggledText={'Tax applied on Taxation Amount'}
          checkBoxListData={taxCheckBoxList}
          noteText={taxNote}
        />
      )}
      {openEditDialog && selectedValue && (
        <InvoiceDrawerLayout
          openDialog={openEditDialog}
          closeDialog={() => setOpenEditDialog(false)}
          onInput={(data) => onUpdateTaxType(data)}
          name="Edit Tex"
          extraField={true}
          addPlaceholder1={editTaxationText}
          addPlaceholder2={editTaxationRateText}
          isToggledEnabled={true}
          toggledText={'Tax applied on Taxation Amount'}
          checkBoxListData={taxCheckBoxList}
          defaultValue={getDefaultValue}
          isTaxTypeDrawer={true}
          noteText={taxNote}
        />
      )}
      {openViewDialog && (
        <InvoiceDrawerLayout
          openDialog={openViewDialog}
          closeDialog={() => setOpenViewDialog(false)}
          onInput={(data) => onUpdateTaxType(data)}
          name="View Tax"
          extraField={true}
          addPlaceholder1={editTaxationText}
          addPlaceholder2={editTaxationRateText}
          isView={true}
          isTaxTypeDrawer={true}
          toggledText={viewApplyToText}
          checkBoxListData={taxCheckBoxList}
          showViewCheckList={showViewTaxCheckList}
          selectedRecordObjectData={taxViewCheckBoxList}
        />
      )}
    </>
  );
};

export default TaxTypeDetails;
